import {useAuthUserStore} from "@/stores/auth";

export default {
    index(academyUuid) {
        return useAuthUserStore().getApiClient.get('/reports/payouts', {
            params: {
                academy_uuid: academyUuid
            }
        })
    }
}